module.exports = __webpack_public_path__ + "static/media/promo.6759ea71.png";